// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-list[data-v-37c001db]{border-radius:8px;min-height:40px;padding:7px 8px;width:200px}.menu-list.active[data-v-37c001db]{background-color:var(--v-m-light-blue-base)}.news-title[data-v-37c001db]{position:relative}.news-title[data-v-37c001db]:after{background-color:var(--v-alert-base);border-radius:50%;content:\"\";height:6px;position:absolute;right:-8px;top:-2px;width:6px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
